import api from "./api";

export interface DashboardData {
  perfil: string;
  minhasTarefasAFazer: number;
  minhasVencidas: number;
  minhasVencendo24h: number;
  proximasTarefas: Array<{ id: string; titulo: string; prazo: string; prazoOriginal: string | null; status: string; projeto: { id: string; nome: string; tipo?: string } | null }>;
  gestor?: {
    projetosAtivos: number;
    projetosAtrasados: number;
    projetosAguardandoCliente: number;
    tarefasAguardandoCliente: number;
    tarefasEquipeVencidas: number;
    parcelasVencidas: number;
    parcelasASete: Array<{ id: string; numero: number; valor: number; vencimento: string; contrato: { projeto: { id: string; nome: string; cliente: string } } }>;
  };
  admin?: {
    usuariosAtivos: number;
    clientesAtivos: number;
  };
}

export async function getDashboard() {
  const r = await api.get("/dashboard");
  return r.data.data as DashboardData;
}
